import React from 'react';
import styles from './Unauthorized.module.css';

export default function Unauthorized() {
  return (
    <div className={styles.unauthorizedRoot}>
      <h1>Unauthorized</h1>
      <p>You don't have permission to access this page.</p>
    </div>
  );
}
  